<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
<template>
  <v-sheet height="100%" color="bg1" width="100%">
    <v-sheet height="100%" class="rounded-tl-lg overflow-hidden pa-4">
      <div
        class="pa-2 d-flex align-center"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>Inspections</h3>
      </div>
      <div class="pa-4">
        <div class="actions-row">
          <div style="width: 250px">Inspection menu</div>

          <input
            v-if="showExcel"
            v-has.any="[permissions.InspectionTags.ImportExport]"
            type="file"
            style="display: none"
            ref="uploadInput"
            id="uploadCSVInspections"
            @change="uploadExcel()"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />

          <v-btn
            v-if="showExcel"
            v-has.any="[permissions.InspectionTags.ImportExport]"
            title="Download Inspections"
            @click.stop="downloadExcel()"
            icon
            :loading="isDownloading"
            ><v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn
            v-if="showExcel"
            v-has.any="[permissions.InspectionTags.ImportExport]"
            title="Upload Inspections"
            @click.stop="showExcelBrowse()"
            icon
            :loading="isUploading"
            ><v-icon>mdi-upload</v-icon>
          </v-btn>
          <v-btn
            v-if="showExcel"
            v-has.any="[permissions.InspectionTags.ImportExport]"
            title="Populate Inspections"
            @click.stop="showExcelBrowse(true)"
            icon
            :loading="isPopulating"
            ><v-icon>mdi-format-page-split</v-icon>
          </v-btn>
          <v-btn
            v-if="showExcel"
            title="Add inspections images"
            v-has.any="[permissions.InspectionTags.Create, permissions.InspectionTags.Update]"
            @click.stop="addInspectionsImages()"
            icon
            ><v-icon>mdi-camera</v-icon>
          </v-btn>

          <v-switch
            @change="toggleIsInspectionsOn"
            v-model="forgeSettings.isInspectionsOn"></v-switch>
        </div>
        <div v-if="isAMIS && forgeSettings.isInspectionsOn">
          <div class="amis-row">
            <div style="width: 250px">Sync With</div>
            <v-sheet class="mr-4">
              <v-select outlined dense items="['A-MIS']"></v-select>
            </v-sheet>

            <v-btn @click="sync()" title="Sync" icon>
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </div>
          <LoadingPopup
            v-if="showProgress"
            :show="showProgress"
            style="position: relative"></LoadingPopup>
          <div
            style="text-align: end; padding: 3px 10px; position: relative"
            v-if="!showProgress && (amisTags.length > 0 || debounceSearch)">
            <SelectionInfo
              :selected_items="selected_items"
              @delete-selection="deleteSelectedItems()"
              v-if="!showProgress"
              @clear-selection="onClearSelection"></SelectionInfo>
            <v-text-field
              outlined
              dense
              hide-details
              clearable
              v-virtual-keyboard
              append-icon="mdi-magnify"
              height="40px"
              label="Search"
              style="width: 300px"
              class="v-min-input"
              placeholder="Search..."
              v-model="debounceSearch">
            </v-text-field>
          </div>
          <div
            v-if="!showProgress && ((amisTags && amisTags.length > 0) || debounceSearch)"
            style="padding-left: 5px; display: flex; overflow-x: auto"
            @scroll="onScroll($event)">
            <ForgeCard
              v-for="element in shownTags"
              :key="element.id"
              style="width: 300px"
              :selectable="element"
              :title="element.lno"
              :watermark="'Inspection'"
              :watermark_color="element.pinColor"
              :url="!element.thumbnailUrl ? getTagPlaceHolder(element) : element.thumbnailUrl"
              :showcheckbox="true"
              @toggle-selection="onToggleSelection"
              @on-card-clicked="zoomToTag(element)"
              @on-selection-changed="updateSelectedItems()">
            </ForgeCard>
          </div>
          <div
            class="info-section"
            style="align-items: center; flex-direction: row"
            v-if="!showProgress">
            <div
              class="admin-btn"
              style="width: fit-content; padding: 8px 30px; min-width: 140px"
              v-if="shownTags.length > 0"
              @click="fillTagsImages()">
              Add All Images
              <span class="pending-requests-counter" v-if="isExpanded && !!pendingRequests"
                >Pending: {{ pendingRequests }}</span
              >
            </div>
            <div
              class="admin-btn"
              style="width: 200px"
              v-if="shownTags.length > 0"
              @click="removeAll()">
              Remove All
            </div>
          </div>
        </div>
        <div v-if="!isAMIS && forgeSettings.isInspectionsOn" class="colors-section">
          <span class="section-header">Colors</span>
          <div class="edit-color-container">
            <div class="filter-colors-container">
              <span>Remaining Thickness</span>
              <div v-for="op in remainingThicknessFilters" :key="op.id" class="color-option">
                <div class="color-option-name">{{ op.name1 }}</div>
                <input
                  type="color"
                  :disabled="!$has(permissions.InspectionTags.Update)"
                  :name="op.id"
                  :id="op.id"
                  v-model="op.judgCor"
                  @input="updateColor(op)" />
                <div v-has="permissions.InspectionTags.Update" class="color-edit-icon fas fa-pen"></div>
                <div class="color-option-name">{{ op.name2 }}</div>
              </div>
            </div>
            <div class="filter-colors-container">
              <span>Remaining Life</span>
              <div v-for="op in remainingLifeFilters" :key="op.id" class="color-option">
                <div class="color-option-name">{{ op.name1 }}</div>
                <input
                  type="color"
                  :disabled="!$has(permissions.InspectionTags.Update)"
                  :name="op.id"
                  :id="op.id"
                  v-model="op.judgCor"
                  @input="updateColor(op)" />
                <div v-has="permissions.InspectionTags.Update" class="color-edit-icon fas fa-pen"></div>
                <div class="color-option-name">{{ op.name2 }}</div>
              </div>
            </div>
            <div class="filter-colors-container">
              <span>Corrosion Rate</span>
              <div v-for="op in corrRateFilters" :key="op.id" class="color-option">
                <div class="color-option-name">{{ op.name1 }}</div>
                <input
                  type="color"
                  :disabled="!$has(permissions.InspectionTags.Update)"
                  :name="op.id"
                  :id="op.id"
                  v-model="op.judgCor"
                  @input="updateColor(op)" />
                <div v-has="permissions.InspectionTags.Update" class="color-edit-icon fas fa-pen"></div>
                <div class="color-option-name">{{ op.name2 }}</div>
              </div>
            </div>
            <div class="filter-colors-container">
              <span>Inspection Plan</span>
              <div v-for="op in inspectionPlanFilters" :key="op.id" class="color-option">
                <div class="color-option-name">{{ op.name1 }}</div>
                <input
                  type="color"
                  :disabled="!$has(permissions.InspectionTags.Update)"
                  :name="op.id"
                  :id="op.id"
                  v-model="op.judgCor"
                  @input="updateColor(op)" />
                <div v-has="permissions.InspectionTags.Update" class="color-edit-icon fas fa-pen"></div>
                <div class="color-option-name">{{ op.name2 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-sheet>
  </v-sheet>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { log, warn, error } from '@/utils/debugLogger';
  import HttpService from '@/utils/httpService';
  import { postDataAsync } from '@/utils/mongoUtils';
  import { isolateForge } from '@/utils/forgeUtils';
  import { getAMISTags } from '@/utils/amisAPIs';
  import { toggleExpandComponent } from '@/scripts/js/forgeviewer';
  import tagHoverImage from '@/images/tagHover.png';
  import notMatchedInspectionImage from '@/images/notMatchedInspection.png';
  import SelectionInfo from '@/components/common/selectionInfo.vue';
  import { $has } from '@/utils';
  import permissions from '@Share/config/permissions';

  export default {
    name: 'AmisSetup',
    components: {
      ForgeCard: () => import('@/components/common/forgeCard.vue'),
      LoadingPopup: () => import('@/components/common/loadingPopup.vue'),
      SelectionInfo,
    },
    data() {
      return {
        permissions,
        isExpanded: false,
        shownTagsLength: 200,
        tempValue: '',
        timeout: null,
        showProgress: false,
        selected_items: [],
        isUploading: false,
        isDownloading: false,
        isPopulating: false,
        uploadUrl: `api/forge/inspections/importInspectionsExcel/${this.$route.params.id}`,
      };
    },
    mounted() {
      this.loadMoreTags(true);
    },
    methods: {
      $has,
      removeAll() {
        if (this.amisTags.length == 0) {
          this.$dialog.notify.warning('No inspections found to delete.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }

        this.$dialog.error({
          text: 'Are you sure you want to delete all A-MIS Inspections?',
          title: 'Delete Inspections',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                this.showProgress = true;
                return postDataAsync(
                  `api/AMIS/deleteAll?assetId=${this.$route.params.id}`,
                  null,
                  () => {
                    this.$store.state.TAGS.amisTags = [];
                    this.showProgress = false;
                  },
                );
              },
            },
          },
        });
      },
      addInspectionsImages() {
        if (this.showProgress) return;

        this.adminAppContainer.open3dViewerIfNot();

        this.showProgress = true;

        this.$store.dispatch('getInspectionsToCapture', {
          assetId: this.$route.params.id,
          callback: () => {
            this.showProgress = false;
            this.$store.commit('SET_FILLING_INSPECTIONS_IMAGES', true);
          },
        });
      },
      sync() {
        if (this.amisToken) {
          this.$store.state.TAGS.showAdminSyncPopup = true;
        } else {
          this.$dialog.notify.warning('Please wait we are connecting with A-MIS.', {
            position: 'top-right',
            timeout: 3000,
          });
        }
      },
      toggleIsInspectionsOn() {
        postDataAsync('api/forge/settings/updateIsInspectionOn', {
          assetId: this.$route.params.id,
          IsInspectionOn: this.forgeSettings.isInspectionsOn,
        });
      },
      updateInspectionFiltersColors(colors, callback) {
        postDataAsync(
          'api/forge/settings/updateInspectionFiltersColors',
          { assetId: this.$route.params.id, colors: colors },
          callback,
        );
      },
      toggleExpanded() {
        toggleExpandComponent(this);
      },
      fillTagsImages() {
        if (this.amisTags.length == 0) {
          this.$dialog.notify.warning('No inspections found!', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        this.adminAppContainer.open3dViewerIfNot();
        this.showProgress = true;
        this.$store.dispatch('fetchAllAMISTagsDbids', {
          assetId: this.$route.params.id,
          fetched: true,
          callback: () => {
            this.showProgress = false;
            this.$store.commit('SET_FILLING_AMIS_TAGS_IMAGES', true);
          },
        });
      },
      onScroll($event) {
        var elem = $event.target;
        if (
          elem.scrollWidth - elem.scrollLeft < 0.2 * elem.scrollWidth &&
          this.shownTags.length < this.totalCount
        ) {
          this.shownTagsLength += 100;
          this.loadMoreTags(false);
        }
      },
      zoomToTag(element) {
        if (!element.children || element.children.length == 0) {
          this.$dialog.notify.warning('Tag is not matching any 3d object.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        this.adminAppContainer.open3dViewerIfNot();
        if (this.$store.state.viewer)
          isolateForge(this.$store.state.viewer, this.$store.state.viewer.model,
            element.children.map(c => c.dbId)
          );
      },
      updateSelectedItems() {
        this.selected_items = this.amisTags.filter((o) => o.isSelected);
      },
      deleteSelectedItems() {
        if (this.selected_items.length == 0) {
          this.$dialog.notify.warning('No inspections selected, please select inspections first.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }

        this.$dialog.error({
          text: 'Are you sure you want to delete selected inspections?',
          title: 'Delete Inspections',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                this.showProgress = true;
                return postDataAsync(
                  'api/AMIS/deleteInspections',
                  { ids: this.selected_items.map((o) => o.id) },
                  () => {
                    let tags = this.amisTags;
                    this.selected_items.forEach((tag) => {
                      var index = tags.indexOf(tag);
                      tags.splice(index, 1);
                    });
                    this.updateSelectedItems();
                    this.showProgress = false;
                  },
                );
              },
            },
          },
        });
      },
      downloadExcel() {
        if (this.isDownloading) return;
        this.isDownloading = true;

        const link = document.createElement('a');
        link.setAttribute('download', 'Inspections.xlsx');
        document.body.appendChild(link);

        HttpService.get({
          url: `api/forge/inspections/exportInspectionsExcel/${this.$route.params.id}`,
          responseType: 'blob',
        })
          .then((response) => {
            let blob = response.data;
            const objectUrl = URL.createObjectURL(blob);
            link.setAttribute('href', objectUrl);
            link.click();
            URL.revokeObjectURL(objectUrl);
          })
          .catch((err) => error('Download error', err))
          .finally(() => {
            this.isDownloading = false;
          });

        document.body.removeChild(link);
      },
      showExcelBrowse(populate = false) {
        if (this.isUploading || this.isPopulating) return;

        this.uploadUrl = populate
          ? `api/forge/inspections/populateInspectionsExcel/${this.$route.params.id}`
          : `api/forge/inspections/importInspectionsExcel/${this.$route.params.id}`;

        this.$refs.uploadInput.click();
      },
      uploadExcel() {
        if (this.uploadUrl.includes('populateInspectionsExcel')) {
          this.isPopulating = true;
        } else {
          this.isUploading = true;
        }

        let file = this.$refs.uploadInput.files[0];
        let formData = new FormData();
        formData.set('file', file);
        HttpService.post({
          url: this.uploadUrl,
          data: formData,
          headers: {
            'Content-Type': false,
            processData: false,
          },
        })
          .then((response) => {
            this.$dialog.notify.success('Inspections updated successfully.', {
              position: 'top-right',
              timeout: 3000,
            });
          })
          .catch((error) => {
            this.$dialog.notify.warning('An Error occurred when updating inspections.', {
              position: 'top-right',
              timeout: 3000,
            });
          }).finally(() => {
            this.isPopulating = false;
            this.isUploading = false;
          });

        this.$refs.uploadInput.value = '';
      },
      getTagPlaceHolder(tag) {
        return !!tag?.point || !!tag?.children?.length ? tagHoverImage : notMatchedInspectionImage;
      },
      updateColor(op) {
        let colors = this.$store.state.forgeSettings.getInspectionFiltersColors();
        let target = colors.find((o) => o.code == op.code && o.symbol == op.judgSymb);
        target.color = op.judgCor;
        colors = JSON.stringify(colors);
        this.updateInspectionFiltersColors(colors, () => {
          this.$store.state.forgeSettings.inspectionFiltersColors = colors;
        });
      },
      extractFiltersData(data) {
        return data.map((o) => {
          return {
            id: `${o.code}-${o.codeOrdr}`,
            title: o.title,
            code: o.code,
            judgSymb: o.judgSymb,
            name1: o.judgMkr1
              ? (o.judgMkr1.includes('<=') ? '≤' : o.judgMkr1) + ' ' + o.judgCrr1
              : 'N/A',
            name2: o.judgMkr2
              ? (o.judgMkr2.includes('>=') ? '≥' : o.judgMkr2) + ' ' + o.judgCrr2
              : 'N/A',
            judgCor: o.judgCor,
            judgCrr1: o.judgCrr1,
            judgMkr1: o.judgMkr1,
            judgCrr2: o.judgCrr2,
            judgMkr2: o.judgMkr2,
          };
        });
      },
      onClearSelection() {
        this.selected_items.forEach((o) => (o.isSelected = false));
        this.updateSelectedItems();
      },
      onToggleSelection(data) {
        let { item, value } = data;
        item.isSelected = value;
      },
      loadMoreTags(reload) {
        if (reload) this.showProgress = true;
        let currentCount = reload ? 0 : this.shownTags.length;
        getAMISTags(currentCount, 200, this.debounceSearch, reload).then(() => {
          this.showProgress = false;
        });
      },
    },
    computed: {
      forgeSettings() {
        return this.$store.state.forgeSettings;
      },

      amisTags() {
        return this.$store.state.TAGS.amisTags;
      },
      shownTags() {
        return this.amisTags;
      },
      amisToken() {
        return this.$store.getters['GET_AMIS_TOKEN'];
      },
      pendingRequests: {
        get() {
          return this.$store.getters['GET_REQUESTED_IMAGES_IDS']?.length ?? 0;
        },
      },
      isAMIS() {
        return this.$store.state.forgeSettings?.isAMIS;
      },
      showExcel() {
        return this.forgeSettings.isInspectionsOn;
      },
      remainingLifeFilters() {
        return this.extractFiltersData(this.$store.state.TAGS.InspectionRemainingLifeColorOptions);
      },
      remainingThicknessFilters() {
        return this.extractFiltersData(this.$store.state.TAGS.InspectionThickPlanColorOptions);
      },
      corrRateFilters() {
        return this.extractFiltersData(this.$store.state.TAGS.InspectionCorrRateColorOptions);
      },
      inspectionPlanFilters() {
        return this.extractFiltersData(this.$store.state.TAGS.InspectionPlanColorOptions);
      },
      totalCount() {
        return this.$store.getters['GET_AMIS_TAGS_TOTAL_COUNT'];
      },
      adminAppContainer: {
        get() {
          return this.$store.state.adminAppContainer;
        },
      },
      debounceSearch: {
        get() {
          return this.tempValue;
        },
        set(val) {
          this.tempValue = val;
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.searchText = this.debounceSearch;
            this.shownTagsLength = 200;
            this.loadMoreTags(true);
          }, 600);
        },
      },
    },
  };
</script>

<style>
  .amis-row {
    display: flex;
    padding: 10px 20px;
    align-items: baseline;
  }

  .sync-btn {
    cursor: pointer;
    width: 30px;
    height: 30px;
    color: gray;
    font-size: 20px;
  }

  .sync-btn:hover {
    color: var(--v-primary-base);
  }

  .actions-row {
    display: flex;
    padding: 10px 20px;
    align-items: center;
  }

  .colors-section {
    display: flex;
    padding: 10px 20px;
    row-gap: 10px;
    flex-direction: column;
  }

  .colors-section .section-header {
    font-size: 20px;
    font-weight: 700;
  }

  .edit-color-container {
    display: flex;
    column-gap: 50px;
  }

  .filter-colors-container {
    width: 100%;
    max-width: 150px;
    display: flex;
    justify-content: center;
    row-gap: 5px;
    flex-direction: column;
    align-items: center;
    height: fit-content;
  }

  .filter-colors-container span {
    font-size: 14px;
    font-weight: 700;
  }

  .color-option {
    position: relative;
    cursor: default;
    margin: 2px 3px;
    border: 1px solid lightgray;
    width: 90%;
    border-radius: 20px;
    height: 28px !important;
    flex-grow: 1;
    display: inline-flex;
  }

  .color-option-count {
    color: var(--v-primary-base);
    width: 50%;
    text-align: center;
    padding-top: 3px;
  }

  .color-option-count i {
    color: #000000;
  }

  .color-option input[type='color'] {
    border: none;
    border-radius: 0;
    height: auto;
    padding-left: 0;
    background: transparent;
  }

  .color-option input[type='color']:hover {
    cursor: pointer;
  }

  .color-option input[type='color']::-moz-color-swatch {
    border: none;
  }

  .color-option input[type='color']::-webkit-color-swatch-wrapper {
    padding: 0;
    border-radius: 0;
  }

  .color-option input[type='color']::-webkit-color-swatch {
    border: none;
  }

  .inspection-plan-options .color-option-name {
    width: 100%;
    border-radius: 20px;
    color: white;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0px;
  }

  .color-option-name {
    color: var(--v-primary-base);
    width: 50%;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
  }

  .color-edit-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  .color-edit-icon:hover {
    color: var(--v-primary-base);
  }
</style>
